import {Inject, Injectable} from '@angular/core';
import {GeneralService} from "../general.service";
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class BasicEntityService extends GeneralService {

  constructor(
    public http: HttpClient,
    @Inject('httpBaseSettings') public httpBaseSettings: any
  ) {
    super(http, httpBaseSettings);
    this.setModelPath('/base/sysDataModelField');
  }

  searchById(url, id) {
    return this.http.post(this.httpBase + url + '/search', {id: id}).pipe(map(res => res['data'] ? res['data'] : []));
  }
  searchByURL(method, url, id) {
    return this.http[method](this.httpBase + url + '/search', {id: id}).pipe(map(res => res['data'] ? res['data'] : []));
  }
}
